/**
 * The title block at the top of a page.
 *
 * Separate from PageContainer, which owns width and padding only. Keeping them
 * apart means a page that needs a custom header (a week picker, a filter bar) can
 * still use the same container without fighting a header it did not want.
 */
export function PageHeader({
  title,
  description,
  actions,
}: {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0 space-y-1">
        <h1 className="text-xl font-bold tracking-[-0.02em]">{title}</h1>
        {description && (
          <p className="text-sm leading-relaxed text-muted-foreground">{description}</p>
        )}
      </div>
      {actions && <div className="flex shrink-0 gap-2">{actions}</div>}
    </div>
  );
}
